import { Loader2, RefreshCw, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';

const VARIANT_CLASS = {
  inline: 'h-7 text-[10px] px-2',
  thumb: 'h-7 text-[10px] px-2',
  dialog: 'h-7 text-xs',
  reel: 'h-7 text-[10px] border-white/15 text-slate-100',
  reelExpanded: 'h-7 text-[10px] border-white/15 text-slate-100 w-full justify-start',
};

/**
 * Shared retry / generate / regenerate control driven by `panelImage` state.
 * Completed panels show a compact refresh icon; missing/failed panels show retry with label.
 */
export function ImageStoryPanelRetryButton({
  panelImage,
  busy = false,
  onClick,
  variant = 'inline',
  className = '',
  testId,
}) {
  const canRetry = panelImage?.canRetry;
  const canRegenerate = panelImage?.canRegenerate;
  if (!canRetry && !canRegenerate) return null;

  const variantClass = VARIANT_CLASS[variant] || VARIANT_CLASS.inline;
  const isReel = variant === 'reel' || variant === 'reelExpanded';

  if (canRegenerate) {
    return (
      <Button
        type="button"
        size="icon"
        variant="outline"
        className={`h-7 w-7 shrink-0 bg-black/55 border-white/20 text-slate-100 hover:bg-black/70 ${className}`.trim()}
        disabled={busy}
        onClick={onClick}
        aria-label={panelImage.regenerateLabel || 'Regenerate image'}
        title={panelImage.regenerateLabel || 'Regenerate image'}
        data-testid={testId || `image-story-scene-regenerate-${panelImage.panelNumber}`}
      >
        {busy ? (
          <Loader2 className="w-3.5 h-3.5 animate-spin" />
        ) : (
          <RefreshCw className="w-3.5 h-3.5" />
        )}
      </Button>
    );
  }

  return (
    <Button
      type="button"
      size="sm"
      variant="outline"
      className={`${variantClass} ${className}`.trim()}
      disabled={busy}
      onClick={onClick}
      data-testid={testId || `image-story-scene-retry-${panelImage.panelNumber}`}
    >
      {busy ? (
        <Loader2 className="w-3 h-3 animate-spin mr-1" />
      ) : (
        <RotateCcw className={`w-3 h-3 ${isReel ? 'mr-1' : 'mr-1'}`} />
      )}
      {panelImage.retryLabel}
    </Button>
  );
}
